import {
    awsUrl,
    awsUrl2,
  } from "../config";

export const ENDPOINTS = {
    USER_TABLE_DATA : `${awsUrl2}/api/userTableData`
}